import { CardSvg } from '@/play/cardSvg'

/** Home card art: a drizzle of bright goo draped over steps, a rock and a dish. */
export function SludgeCardArt() {
  return (
    <CardSvg bg="#eef0ea">
      <rect y="150" width="320" height="50" fill="#f4efe6" />
      {/* steps, a rock, a dish */}
      <path d="M30 150 V 134 H 62 V 118 H 94 V 102 H 126 V 150 Z" fill="#e3dbcd" />
      <path d="M150 150 C 152 112, 206 112, 208 150 Z" fill="#d9d3cc" />
      <path d="M228 150 C 232 132, 236 128, 244 128 L 298 128 C 306 128, 310 132, 312 150 Z" fill="#d6e2ea" />
      {/* one long drizzle draped over all of it */}
      <path
        d="M36 134 C 50 128, 58 130, 62 132 C 66 136, 66 120, 70 118 C 82 112, 90 116, 94 118 C 98 122, 96 104, 102 101 C 112 96, 122 100, 126 104 C 130 112, 128 140, 134 148 C 142 152, 148 140, 156 126 C 166 110, 194 110, 202 124 C 210 140, 218 150, 226 146 C 234 136, 240 128, 252 130 C 266 134, 280 138, 296 132"
        fill="none" stroke="#ff5fa2" strokeWidth="9" strokeLinecap="round" strokeLinejoin="round"
      />
      <path d="M126 104 C 129 114, 128 132, 131 140" fill="none" stroke="#ff5fa2" strokeWidth="11" strokeLinecap="round" />
      <ellipse cx="300" cy="131" rx="11" ry="8" fill="#ff5fa2" />
      <path d="M170 113 C 180 108, 190 109, 196 114" fill="none" stroke="#ffffff" strokeWidth="2.5" strokeLinecap="round" opacity="0.6" />
      <path d="M40 150 C 42 142, 56 140, 60 150 Z" fill="#7ee35b" />
    </CardSvg>
  )
}
